<template>
  <div>

    <a @click="$emit('expandWithId', id)" class="config-name" :class="{'expanded': isExpanded}">
      <div class="invoice-amount"><span class="amount">{{this.id + 1}}</span></div>
      {{ this.cilinderName }} <span class="comment">{{ this.cilinderSubName }}</span></a>
    <span class="delete" @click="$emit('deleteConfig', id)" v-show="this.groups.length > 1">{{ $t('cylinder.quotationPopup.delete') }}</span>
    <transition name="collapse">
      <div class="cilinder-options" v-show="this.isExpanded">

        <div class="option">
          <menu-item :label="$t('cylinder.quotationPopup.circuit')" tooltip-key="tooltip_hydraulic_circuit">
            <form class="radio-container">
              <input type="radio" :value="1" v-model="circuit" :name="`${id}custom-circuit`" :id="`${id}circuit-1`" @click="() => $emit('update:circuit', 1)">
              <label :for="`${id}circuit-1`">{{ $t('cylinder.quotationPopup.double') }}</label>
              <input type="radio" :value="2" v-model="circuit" :name="`${id}custom-circuit`" :id="`${id}circuit-2`" @click="() => $emit('update:circuit', 2)">
              <label :for="`${id}circuit-2`">{{ $t('cylinder.quotationPopup.single') }}</label>
            </form>
          </menu-item>
        </div>
        <div class="option">
          <menu-item-number
              tooltip-key="tooltip_cilinder_piston"
              :label="$t('cylinder.quotationPopup.pistonDiameter')"
              @change="(val) => $emit('update:pistonDiameter', val)"
              :val="pistonDiameter"
              unit="mm">
          </menu-item-number>
        </div>
        <div class="option">
          <menu-item-number
              tooltip-key="tooltip_cilinder_rod"
              :label="$t('cylinder.quotationPopup.rodDiameter')"
              @change="(val) => $emit('update:rodDiameter', val)"
              :val="rodDiameter"
              unit="mm">
          </menu-item-number>
        </div>
        <div class="option">
          <menu-item-number
              tooltip-key="tooltip_cilinder_stroke"
              :label="$t('cylinder.quotationPopup.stroke')"
              @change="(val) => $emit('update:stroke', val)"
              :val="stroke"
              unit="mm">
          </menu-item-number>
        </div>

        <div class="option">
          <menu-item :label="$t('cylinder.quotationPopup.attachment1')"
                     tooltip-key="tooltip_cilinder_attachment">
            <input-dropdown :options="types" :value="attachment1" @change="handleInput1"></input-dropdown>
          </menu-item>
        </div>
        <div class="option">
          <menu-item :label="$t('cylinder.quotationPopup.attachment2')"
                     tooltip-key="tooltip_cilinder_attachment">
            <input-dropdown :options="types" :value="attachment2" @change="handleInput2"></input-dropdown>
          </menu-item>
        </div>

        <div class="option">
          <menu-item-amount :label="$t('cylinder.quotationPopup.amount')" @change="(val) => $emit('update:amount', val)"></menu-item-amount>
        </div>

        <div class="option">
          <menu-item :label="$t('cylinder.quotationPopup.description')" :info="false" style="margin-left: -260px;">
            <textarea rows="6" cols="50" name="comments" style="min-width: 500px;"
                      @change="(val) => $emit('update:comment', val.target.value)"
            ></textarea>
          </menu-item>
        </div>

      </div>
    </transition>
  </div>
</template>

<script>
import Popup from "./Popup";
import Dropdown from "../input/Dropdown";
import MenuItemNumber from "../step2/menu/MenuItemNumber";
import MenuItem from "../step2/menu/MenuItem";
import InputDropdown from "../input/Dropdown";
import MenuItemAmount from "@/components/step2/menu/MenuItemAmount";

import {mapGetters} from 'vuex';
import Label from "@/components/input/Label";
import { getFromStorage } from "@/helpers/backendStorage";

export default {
  name: "PopupCilinderConfigurator",

  components: {
    Label,
    MenuItemAmount,
    Popup,
    Dropdown,
    MenuItemNumber,
    MenuItem,
    InputDropdown,
  },
  props: ['id', 'groups', 'cilinderName', 'cilinderSubName', 'stroke', 'pistonDiameter', 'rodDiameter', 'circuit', 'comment', 'attachment1', 'attachment2', 'isExpanded', 'attachments', 'amount'],

  data() {
    return {
      types: [
        {key: 1, value: this.$t('cylinder.quotationPopup.attachments.noAttachment'), recommended: 0},
        {key: 2, value: this.$t('cylinder.quotationPopup.attachments.jointEye'), recommended: 0},
        {key: 3, value: this.$t('cylinder.quotationPopup.attachments.standard'), recommended: 0},
        {key: 4, value: this.$t('cylinder.quotationPopup.attachments.frontFlange'), recommended: 0},
        {key: 5, value: this.$t('cylinder.quotationPopup.attachments.fork'), recommended: 0},
        {key: 6, value: this.$t('cylinder.quotationPopup.attachments.topLinkEye'), recommended: 0},
        {key: 7, value: this.$t('cylinder.quotationPopup.attachments.wideAttachment'), recommended: 0},
        {key: 8, value: this.$t('cylinder.quotationPopup.attachments.eye'), recommended: 0},
      ],
    }
  },
  computed: {
    ...mapGetters({
      selectedCilinder: 'preference/getSelectedCilinder',
      user: 'auth/getUser',
    }),
    circuitId(){
      return this.id
    },
    circuitIdPlus(){
      return -this.id
    },
    typesFiltered() {
      let imageName = this.circuit === 1 ? "image_double" : "image_single"
      let array = this.attachments.filter((attachments) => {
        return getFromStorage(attachments[imageName]);
      });

      array = array.map((a) => {
        return {key: a.id, value: a.name}
      }) || this.types;

      array.unshift({key: 0, value: 'Alle bevestigingen'});
      return array;
    },
  },
  methods: {
    handleInput1(id) {
      this.$emit('update:attachment1', id)
    },
    handleInput2(id) {
      this.$emit('update:attachment2', id)
    },
  },
}
</script>

<style scoped lang="scss">
.title {
  padding: 20px;
  font-size: 20px;
  font-family: neue-haas-grotesk-display, sans-serif;
  font-weight: 700;
}

.custom-cilinder-popup {
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .form-group {
    display: flex;
    flex-direction: column;
    flex-basis: 33%;

    &:nth-child(5) {
      flex-basis: 31%;
    }

    label {
      font-family: neue-haas-grotesk-display, sans-serif;
      font-weight: 700;
      font-size: 14px;
      display: flex;
      margin-bottom: 2px;
      position: relative;
      margin-left: 20px;
    }

    .dropdown {
      max-width: 100%;
    }

    textarea {
      padding-top: 6px;
    }

    input, textarea {
      padding-left: 8px;
    }

    input, textarea, .dropdown {
      width: 100%;
      margin-left: auto;
      margin-right: 200px;
      min-height: 40px;
      border: 2px solid #EBEBEB;
      outline: none;
      border-radius: 25px;
    }
  }
}

  .custom-cilinder-row {
    display: flex;
    flex-direction: column;

    .custom-cilinder-item {
      width: 100%;
      height: auto;
      padding: 10px 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .invoice-amount {
        padding: 10px;
        margin-right: 5px;
        border: 2px solid #EBEBEB;
        outline: none;
        height: 30px;
        width: 30px;
        position: relative;
        border-radius: 50%;
        display: flex;
        justify-content: center;

        .amount {
          display: flex;
          align-self: center;
          font-size: 20px;
          color: rgba(0, 0, 0, 0.5);
        }
      }

      .config-name {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        flex-direction: row;
        font-size: 14px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.4);
        cursor: pointer;
        transition: all ease 0.2s;

        &:hover {
          color: #3db0c7;
        }

        &.expanded {
          color: rgba(0, 0, 0, 1);
        }

        .comment {
          margin-left: 35px;
          display: flex;
          flex-basis: 100%;
          flex-wrap: wrap;
          font-style: italic;
          color: rgba(0, 0, 0, 0.7);
        }
      }

      .delete {
        margin-left: auto;
        cursor: pointer;
        transition: all ease 0.3s;
        font-weight: 700;
        color: darkred;

        &:hover {
          color: red;
        }
      }

      hr {
        border-top: 2px solid rgba(0, 0, 0, .1);
      }

      .cilinder-options {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;

        .option {
          width: 32%;

          &:last-child {
            justify-content: unset;
          }


          textarea {
            min-width: 420px;
            height: 40px;
            border: 2px solid #EBEBEB;
            outline: none;
            border-radius: 25px;
            padding-left: 8px;
            padding-top: 8px;
            resize: none;
          }
        }
      }
    }
  }

.radio-container {
  width: 100%;
  border-radius: 50px;
  border: 2px solid #EBEBEB;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: white;
  transition: all ease 0.3s;

  label {
    cursor: pointer;
    display: flex;
    justify-content: center;
    font-size: 12px;
    margin: 0;
    border-radius: 25px;
    width: 50%;
    padding: 9px;
    user-select: none;
    font-family: neue-haas-grotesk-display, sans-serif;
  }

  input[type="radio"] {
    display: none;


    &:checked + label {
      background-color: #3DB0C7;
      color: white;
    }
  }
}

//animations
.collapse-enter-to, .collapse-leave {
  max-height: 300px;
  overflow: hidden;
}
.collapse-enter, .collapse-leave-to {
  overflow: hidden;
  max-height: 0;
}
.collapse-enter-active {
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

.collapse-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

.btn-invoice {
  display: flex;
  border-radius: 5px;
  color: white;
  border: none;
  height: 36px;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
  width: auto;
  padding: 0 10px;
  margin-left: auto;
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 14px;
  font-family: neue-haas-grotesk-display, sans-serif;
  transition: all ease 0.3s;
  letter-spacing: 0.5px;
  background-color: #71BC03;
  outline: none;

  &:hover {
    background-color: darken(#71BC03, 10%);
    color: white;
  }
}

.btn-add-invoice {
  display: flex;
  border-radius: 5px;
  color: white;
  border: none;
  height: 36px;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
  width: auto;
  padding: 0 10px;
  margin-right: auto;
  margin-bottom: 20px;
  margin-top: 10px;
  font-size: 14px;
  font-family: neue-haas-grotesk-display, sans-serif;
  transition: all ease 0.3s;
  letter-spacing: 0.5px;
  background-color: #AFAFAF;
  outline: none;

  &:hover {
    background-color: darken(#AFAFAF, 10%);
    color: white;
  }
}

</style>
